export const homeLocation = '/'
export const aboutLocation = '/about'
export const jobsLocation = '/jobs'
export const freelancerLocation = jobsLocation + '/freelancer'
export const consultantLocation = jobsLocation + '/consultant'
export const contactLocation = '/contact'
export const privacyLocation = '/privacy-policy'
export const cookieLocation = '/cookies'
export const siteMapLocation = '/site-map'